import { jsxs, jsx } from "react/jsx-runtime";
const OutputsIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx("path", { d: "M718.1,240h-608c-17.7,0-32,14.3-32,32v608c0,17.7,14.3,32,32,32h608c17.7,0,32-14.3,32-32V272 C750.1,254.3,735.8,240,718.1,240z M284.1,840h-134V706h134V840z M284.1,642h-134V510h134V642z M284.1,446h-134V312h134V446z M480.1,840h-132V706h132V840z M480.1,642h-132V510h132V642z M480.1,446h-132V312h132V446z M678.1,840h-134V706h134V840z M678.1,642 h-134V510h134V642z M678.1,446h-134V312h134V446z" }),
  /* @__PURE__ */ jsx("path", { d: "M230.1,112h616c17.7,0,32,14.3,32,32v616c0,4.4-3.6,8-8,8h-56c-4.4,0-8-3.6-8-8V184h-576c-4.4,0-8-3.6-8-8v-56 C222.1,115.6,225.7,112,230.1,112z" })
] });
export {
  OutputsIcon
};
